"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedTechnologies = void 0;
var react_1 = __importStar(require("react"));
// @ts-ignore
var classnames_1 = __importDefault(require("classnames"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var selected_technologies_styles_1 = require("./selected_technologies_styles");
var last_1 = __importDefault(require("lodash/last"));
var styles_1 = require("@material-ui/core/styles");
var technologies_picker_context_1 = require("../technologies_picker_context");
var index_1 = require("../../index");
var trash_1 = require("../../assets/icons/trash");
var move_1 = require("../../assets/icons/move");
var useStyles = styles_1.makeStyles(selected_technologies_styles_1.styles);
var TechnologyRow = react_sortable_hoc_1.SortableElement(function (_a) {
    var item = _a.item, onRemove = _a.onDelete, onChange = _a.onChange, itemsLength = _a.itemsLength, technologyIndex = _a.technologyIndex;
    var classes = useStyles();
    var _b = react_1.useContext(technologies_picker_context_1.TechnologiesPickerContext), technologies = _b.technologies, translations = _b.translations;
    var sliderChange = react_1.useCallback(function (e) {
        onChange(__assign(__assign({}, item), { value: Number(e.target.value) }));
    }, [item, onChange]);
    var imgUrl = react_1.useMemo(function () {
        var _a;
        var matchingItem = technologies.find(function (techno) { return techno.name === item.name; });
        if (matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.handle) {
            return "https://process.filestackapi.com/auto_image/" + ((_a = matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.handle) !== null && _a !== void 0 ? _a : '4A5N89okRPW50jRcmkuM');
        }
        var handle = last_1.default(matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.url.split('/'));
        return "https://process.filestackapi.com/auto_image/" + (handle !== null && handle !== void 0 ? handle : '4A5N89okRPW50jRcmkuM');
    }, [item, technologies]);
    return (react_1.default.createElement("li", { className: classes.listItem, style: { zIndex: itemsLength - technologyIndex } },
        react_1.default.createElement(DragHandle, { classes: classes }),
        react_1.default.createElement("div", { className: classes.divider }),
        react_1.default.createElement(index_1.Tooltip, { title: translations.deleteLabel },
            react_1.default.createElement("button", { className: classes.removeButton, type: "button", onClick: function () { return onRemove(item.name); } },
                react_1.default.createElement(trash_1.TrashIcon, { className: classes.removeIcon }))),
        react_1.default.createElement("div", { className: classes.divider }),
        react_1.default.createElement(index_1.Card, { className: classes.logo },
            react_1.default.createElement("img", { className: classes.logoImage, alt: item.name, src: imgUrl })),
        react_1.default.createElement("div", { className: classes.textWrapper },
            react_1.default.createElement(index_1.Typography, { color: "dark", variant: "label" }, item.name),
            react_1.default.createElement("div", { className: classes.sliderValueContainer },
                react_1.default.createElement(index_1.Typography, { classes: {
                        container: classes.sliderValue,
                    }, color: "dark", variant: "label" },
                    react_1.default.createElement("span", { className: classes.bolden }, item.value),
                    "%"),
                react_1.default.createElement(index_1.Slider, { color: "primary", name: "skill_value_" + item.name, value: item.value, onChange: sliderChange, min: 0, max: 100, step: 5, debounce: 50, classes: { container: classes.slider }, popperCardProps: {
                        classes: {
                            popper: classes.popper,
                        },
                    } })))));
});
var SortableTechnologies = react_sortable_hoc_1.SortableContainer(function (_a) {
    var items = _a.items, onDelete = _a.onDelete, onItemChange = _a.onItemChange, receivedClasses = _a.classes, className = _a.className, itemsLength = _a.itemsLength;
    var classes = useStyles({ classes: receivedClasses });
    return (react_1.default.createElement(index_1.List, { className: classnames_1.default(classes.container, className) }, items.map(function (item, index) { return (react_1.default.createElement(TechnologyRow, { key: "selected_technology_row_" + item.name, onDelete: onDelete, id: item.name, onChange: onItemChange, technologyIndex: index, index: index, item: item, itemsLength: itemsLength })); })));
});
var DragHandle = react_sortable_hoc_1.SortableHandle(function (_a) {
    var classes = _a.classes;
    return (react_1.default.createElement("button", { className: classes.dragHandleButton, type: "button" },
        react_1.default.createElement(move_1.MoveIcon, { className: classes.dragHandle })));
});
var SelectedTechnologiesComponent = function (_a) {
    var items = _a.items, onChange = _a.onChange, onDelete = _a.onDelete, className = _a.className, onItemChange = _a.onItemChange, _b = _a.classes, receivedClasses = _b === void 0 ? {} : _b;
    var classes = useStyles({ classes: receivedClasses });
    var itemsLength = react_1.useMemo(function () { return items.length; }, [items]);
    var move = react_1.useCallback(function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        onChange(react_sortable_hoc_1.arrayMove(items, oldIndex, newIndex).map(function (data, index) { return (__assign(__assign({}, data), { index: index })); }));
    }, [items, onChange]);
    return (react_1.default.createElement(SortableTechnologies, { lockToContainerEdges: true, className: className, helperClass: classes.sortableHelper, items: items, onSortEnd: move, distance: 20, useDragHandle: true, lockAxis: "y", onItemChange: onItemChange, onDelete: onDelete, itemsLength: itemsLength, onChange: onChange, classes: receivedClasses }));
};
exports.SelectedTechnologies = SelectedTechnologiesComponent;
